import { IsNotEmpty, IsNumber, IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

import { Communicator } from './communicator';
import createCollectionResource from 'src/actions/shared/createResource';
import validateType, { translateErrors } from 'src/adapters/validateType';
import { DomainError } from '@ad-scripts/application/lib/error';

class RecipientCollection {
  @IsNotEmpty()
  id: string;

  @IsNotEmpty()
  campaignId: string;

  @ValidateNested()
  @Type(() => Communicator)
  createdBy: Communicator;

  @IsNotEmpty()
  createdAt: string;

  @IsNotEmpty()
  type: string;

  @IsString()
  @IsNotEmpty()
  startAfter: string;

  @IsString()
  endBefore: string;

  @IsNumber()
  completedRecipients: number;

  @IsNumber()
  totalRecipients: number;

  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsNotEmpty()
  status: string;

  @IsNumber()
  version: number;
}

export class AddRecipientCollectionDto {
  @IsNotEmpty()
  @ValidateNested()
  @Type(() => CsvFile)
  csvFile: CsvFile;
}

class CsvFile {
  @IsNotEmpty()
  name: string;
}

const recipientCollectionsResource = createCollectionResource<RecipientCollection>({
  name: 'recipientCollections',
  endpoint: 'v1/orgs/:orgId/campaigns/:campaignId/recipientcollections/:id',
  options: {
    complexKey: ['id', 'campaignId'],
    toastMessages: {
      onAdd: item => `"${item.csvFile.name}" recipients have been added.`,
      onAddFail: item => `Unable to add "${item.csvFile.name}" recipients. Please try again.`,
      onUpdate: item => `"${item.fileName}" campaign has been stopped.`,
      onUpdateFail: item => `Unable to stop "${item.fileName}" outreach. Please try again.`,
      onRemove: item => `"${item.fileName}" outreach has been deleted.`,
      onRemoveFail: item => `Unable to delete "${item.fileName}" outreach. Please try again.`,
    },
  },
  type: RecipientCollection,
});

recipientCollectionsResource.effects.validate = (attrs: any) => dispatch => {
  try {
    validateType(AddRecipientCollectionDto, attrs);
  } catch (err) {
    dispatch(recipientCollectionsResource.actions.validationError(translateErrors((err as DomainError).errors)));
    return false;
  }
  return true;
};

export default recipientCollectionsResource;
